import { render, staticRenderFns } from "./FigmaLayersTree.vue?vue&type=template&id=32bcb802"
import script from "./FigmaLayersTree.vue?vue&type=script&lang=js"
export * from "./FigmaLayersTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32bcb802')) {
      api.createRecord('32bcb802', component.options)
    } else {
      api.reload('32bcb802', component.options)
    }
    module.hot.accept("./FigmaLayersTree.vue?vue&type=template&id=32bcb802", function () {
      api.rerender('32bcb802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/FigmaLayersTree.vue"
export default component.exports